import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#040404",
  900: "#161C24",
};

const PRIMARY = {
  lighter: "#FFE9B3",
  light: "#F7CD72",
  main: "#DDAB2E",
  dark: "#B38626",
  darker: "#80631B",
  contrastText: "#FFFFFF",
};

const SECONDARY = {
  lighter: "#808D9B",
  light: "#0057CC",
  main: "#011B36",
  dark: "#011429",
  darker: "#010E1B",
  contrastText: "#FFFFFF",
};


const palette = {
  mode: "light",
  common: {
    black: "#040404",
    white: "#FFFFFF",
    grey: "#8B8B8B",
    greyLight: "#B3B3B3",
    light: "#FFF2E3",
  },
  primary: PRIMARY,
  secondary: SECONDARY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: "#fff",
    default: "#FFF",
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
